import { useMemo } from 'react';

import type { CommentKeys } from '../../../comments/api/cache/comment-keys';
import { createCommentKeys } from '../../../comments/api/cache/comment-keys';
import type { CommentsApi } from '../../../comments/comments-api-context';
import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';

export const jobProfileCommentKeys: CommentKeys = createCommentKeys('job-profile');

export const useJobProfileCommentsApi = (): CommentsApi => {
    const { jobProfileComments } = useApplicationFetchers();
    return useMemo(() => ({ fetchers: jobProfileComments, keys: jobProfileCommentKeys }), [jobProfileComments]);
};
